export default __webpack_public_path__ + "media/data-analysis.24541ac6f175fde3da7fc48c054e5f52.svg";